import {
  DEBIT_VOUCHER,
  COA,
  ACCOUNTING,
  CREDIT_VOUCHER,
  JOURNAL_VOUCHER,
  DV_APPROVAL,
  CV_APPROVAL,
  JV_APPROVAL,
  ACC_RECONCILATION,
  GL_JOURNAL,
  PENDING_APPROVALS,
  MY_REQUESTS,
  VOUCHER_VIEW,
} from '@constants/internal-route.constant'
import {IAppRoutes} from '@interface/common.interface'
import {VOUCHER_VIEW_ROUTES} from 'layouts/components/sidebar/menu-routes'
import {guard} from './route-guard'

export const AccountingRoutes: IAppRoutes = {
  link: ACCOUNTING,
  childrens: [
    {
      link: COA,
      element: guard(() => import('@modules/accounting/CoA'), [COA]),
    },
    {
      link: DEBIT_VOUCHER,
      element: guard(() => import('@modules/accounting/DebitVoucher'), [DEBIT_VOUCHER]),
    },
    {
      link: CREDIT_VOUCHER,
      element: guard(() => import('@modules/accounting/CreditVoucher'), [CREDIT_VOUCHER]),
    },
    {
      link: JOURNAL_VOUCHER,
      element: guard(() => import('@modules/accounting/JournalVoucher'), [JOURNAL_VOUCHER]),
    },
    {
      // One inbox for every voucher type; open to anyone holding at least one approval feature.
      // The screen offers only the types the user holds.
      link: PENDING_APPROVALS,
      element: guard(() => import('@modules/accounting/PendingApprovals'), [
        DV_APPROVAL,
        CV_APPROVAL,
        JV_APPROVAL,
      ]),
    },
    {
      // The vouchers I prepared: open to anyone who can raise one.
      link: MY_REQUESTS,
      element: guard(() => import('@modules/accounting/MyRequests'), [
        DEBIT_VOUCHER,
        CREDIT_VOUCHER,
        JOURNAL_VOUCHER,
      ]),
    },
    {
      // One voucher's page: from the voucher lists, My Requests and Pending Approvals.
      link: `${VOUCHER_VIEW}/:id`,
      element: guard(() => import('@modules/accounting/VoucherView'), VOUCHER_VIEW_ROUTES),
    },
    // The old per-type screens: saved links and favourites land on the inbox, filtered to the type.
    {link: DV_APPROVAL, redirect: `${PENDING_APPROVALS}?voucherType=DV`},
    {link: CV_APPROVAL, redirect: `${PENDING_APPROVALS}?voucherType=CV`},
    {link: JV_APPROVAL, redirect: `${PENDING_APPROVALS}?voucherType=JV`},
    {
      // ACC_RECONCILATION was declared and rendered as a gated menu item but had no
      // route, so the menu entry fell through to the 404 page.
      link: ACC_RECONCILATION,
      element: guard(() => import('@modules/accounting/Reconciliation'), [ACC_RECONCILATION]),
    },
    {
      link: GL_JOURNAL,
      element: guard(() => import('@modules/accounting/GlJournal'), [GL_JOURNAL]),
    },
  ],
}
